module.exports = __webpack_public_path__ + "media/graceful.771482bc.mp3";